import { cssPluginsFromObject } from '@sail/engine/deprecated';
export const font = cssPluginsFromObject((css)=>({
        font: {
            title: {
                fontSize: css.value('32px'),
                lineHeight: css.value('40px'),
                fontWeight: 'bold'
            },
            subtitle: {
                fontSize: css.value('24px'),
                lineHeight: css.value('32px'),
                fontWeight: 'bold'
            },
            heading: {
                fontSize: css.value('18px'),
                lineHeight: css.value('24px'),
                fontWeight: 'bold'
            },
            subheading: {
                fontSize: css.value('16px'),
                lineHeight: css.value('24px'),
                fontWeight: 'semibold'
            },
            lead: {
                fontSize: css.value('18px'),
                lineHeight: css.value('28px'),
                fontWeight: 'regular'
            },
            kicker: {
                fontSize: css.value('12px'),
                lineHeight: css.value('20px'),
                textTransform: 'uppercase',
                fontWeight: 'semibold'
            },
            body: {
                fontSize: css.value('14px'),
                lineHeight: css.value('20px'),
                fontWeight: 'regular'
            },
            bodyEmphasized: {
                fontSize: css.value('14px'),
                lineHeight: css.value('20px'),
                fontWeight: 'semibold'
            },
            caption: {
                fontSize: css.value('12px'),
                lineHeight: css.value('16px'),
                fontWeight: 'regular'
            }
        }
    }));

//# sourceMappingURL=font.js.map